/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DateRangeFromJSON, DateRangeToJSON, } from './';
export function CampaignListEntryFromJSON(json) {
    return CampaignListEntryFromJSONTyped(json, false);
}
export function CampaignListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'duration': !exists(json, 'duration') ? undefined : DateRangeFromJSON(json['duration']),
        'active': json['active']
    };
}
export function CampaignListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'organisationId': value.organisationId,
        'userId': value.userId,
        'duration': DateRangeToJSON(value.duration),
        'active': value.active
    };
}
